!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.sd = t());
}(this, function () {
  "use strict";

  return [{
    locale: "sd",
    pluralRuleFunction: function (e, t) {
      return t ? "other" : 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "سال",
        relative: {
          0: "پويون سال",
          1: "پويون سال",
          "-1": "پويون سال"
        },
        relativeTime: {
          future: {
            one: "{0} سالن ۾",
            other: "{0} سالن ۾"
          },
          past: {
            one: "{0} سال پهرين",
            other: "{0} سال پهرين"
          }
        }
      },
      "year-short": {
        displayName: "سال",
        relative: {
          0: "پويون سال",
          1: "پويون سال",
          "-1": "پويون سال"
        },
        relativeTime: {
          future: {
            one: "{0} سالن ۾",
            other: "{0} سالن ۾"
          },
          past: {
            one: "{0} سال پهرين",
            other: "{0} سال پهرين"
          }
        }
      },
      month: {
        displayName: "مهينو",
        relative: {
          0: "هن مهيني",
          1: "اڳين مهيني",
          "-1": "پوئين مهيني"
        },
        relativeTime: {
          future: {
            one: "{0} مهينن ۾",
            other: "{0} مهينن ۾"
          },
          past: {
            one: "{0} مهينا پهرين",
            other: "{0} مهينا پهرين"
          }
        }
      },
      "month-short": {
        displayName: "مهينو",
        relative: {
          0: "هن مهيني",
          1: "اڳين مهيني",
          "-1": "پوئين مهيني"
        },
        relativeTime: {
          future: {
            one: "{0} مهينن ۾",
            other: "{0} مهينن ۾"
          },
          past: {
            one: "{0} مهينا پهرين",
            other: "{0} مهينا پهرين"
          }
        }
      },
      day: {
        displayName: "ڏينهن",
        relative: {
          0: "اڄ",
          1: "سڀاڻي",
          "-1": "ڪل"
        },
        relativeTime: {
          future: {
            one: "{0} ڏينهن ۾",
            other: "{0} ڏينهن ۾"
          },
          past: {
            one: "{0} ڏينهن پهرين",
            other: "{0} ڏينهن پهرين"
          }
        }
      },
      "day-short": {
        displayName: "ڏينهن",
        relative: {
          0: "اڄ",
          1: "سڀاڻي",
          "-1": "ڪل"
        },
        relativeTime: {
          future: {
            one: "{0} ڏينهن ۾",
            other: "{0} ڏينهن ۾"
          },
          past: {
            one: "{0} ڏينهن پهرين",
            other: "{0} ڏينهن پهرين"
          }
        }
      },
      hour: {
        displayName: "ڪلاڪ",
        relative: {
          0: "هن ڪلڪ"
        },
        relativeTime: {
          future: {
            one: "{0} ڪلاڪ ۾",
            other: "{0} ڪلاڪ ۾"
          },
          past: {
            one: "{0} ڪلاڪ پهرين",
            other: "{0} ڪلاڪ پهرين"
          }
        }
      },
      "hour-short": {
        displayName: "ڪلاڪ",
        relative: {
          0: "هن ڪلڪ"
        },
        relativeTime: {
          future: {
            one: "{0} ڪلاڪ ۾",
            other: "{0} ڪلاڪ ۾"
          },
          past: {
            one: "{0} ڪلاڪ پهرين",
            other: "{0} ڪلاڪ پهرين"
          }
        }
      },
      minute: {
        displayName: "منٽ",
        relative: {
          0: "هن منٽ"
        },
        relativeTime: {
          future: {
            one: "{0} منٽن ۾",
            other: "+{0} min"
          },
          past: {
            one: "{0} منٽ پهرين",
            other: "{0} منٽ پهرين"
          }
        }
      },
      "minute-short": {
        displayName: "منٽ",
        relative: {
          0: "هن منٽ"
        },
        relativeTime: {
          future: {
            one: "{0} منٽن ۾",
            other: "{0} منٽن ۾"
          },
          past: {
            one: "{0} منٽ پهرين",
            other: "{0} منٽ پهرين"
          }
        }
      },
      second: {
        displayName: "سيڪنڊ",
        relative: {
          0: "هاڻي"
        },
        relativeTime: {
          future: {
            one: "{0} سيڪنڊن ۾",
            other: "{0} سيڪنڊن ۾"
          },
          past: {
            one: "{0} سيڪنڊ پهرين",
            other: "{0} سيڪنڊ پهرين"
          }
        }
      },
      "second-short": {
        displayName: "سيڪنڊ",
        relative: {
          0: "هاڻي"
        },
        relativeTime: {
          future: {
            one: "{0} سيڪنڊن ۾",
            other: "{0} سيڪنڊن ۾"
          },
          past: {
            one: "{0} سيڪنڊ پهرين",
            other: "{0} سيڪنڊ پهرين"
          }
        }
      }
    }
  }];
});